const normalizeType = (type) => {
  const value = String(type || '').toLowerCase().replace(/[\s-]+/g, '_');
  if (['luggage', 'parcel', 'luggage_ticket'].includes(value)) return 'luggage';
  if (['ticket', 'booking', 'passenger', 'passenger_ticket'].includes(value)) return 'ticket';
  return value || null;
};

export const getSystemDetailsUrl = (ref, type, origin = '') => {
  const route = type === 'luggage' ? 'luggage' : 'ticket';
  let baseUrl = String(origin || '').trim().replace(/\/+$/, '');
  
  if (!baseUrl && typeof window !== 'undefined' && window.location) {
    baseUrl = window.location.origin;
  }
  
  if (!baseUrl) {
    baseUrl = 'http://localhost:3000';
  }

  if (!/^https?:\/\//i.test(baseUrl)) {
    baseUrl = `http://${baseUrl}`;
  }

  return `${baseUrl}/qr/${route}/${encodeURIComponent(ref)}`;
};

export const parseQrCode = (raw) => {
  if (!raw) return { ref: '', type: null };

  let text = String(raw).trim();
  let type = null;

  try {
    const payload = JSON.parse(text);
    if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
      type = normalizeType(payload.type || payload.doc_type || payload.document_type);
      text = payload.ref || payload.reference || payload.booking_ref || payload.luggage_ref || payload.ticket_number || text;
    }
  } catch (_) {}

  try {
    if (/^https?:\/\//i.test(text)) {
      const url = new URL(text);
      const parts = url.pathname.split('/').filter(Boolean);
      text = url.searchParams.get('ref') || url.searchParams.get('booking_ref') ||
        url.searchParams.get('luggage_ref') || url.searchParams.get('ticket_number') || parts[parts.length - 1] || '';
      if (!type && parts.some((part) => ['luggage', 'luggage-ticket', 'parcel'].includes(part.toLowerCase()))) {
        type = 'luggage';
      } else if (!type && parts.some((part) => ['ticket', 'booking', 'passenger-ticket'].includes(part.toLowerCase()))) {
        type = 'ticket';
      }
    }
  } catch (_) {}

  return { ref: String(text).trim().toUpperCase(), type };
};